var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSmileys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 14.75c-3.42 0-4.95-1.53-4.95-4.95V6.2c0-3.42 1.53-4.95 4.95-4.95h3.6c3.42 0 4.95 1.53 4.95 4.95V10c0 .41-.33.74-.74.75-2.4.04-3.22.87-3.26 3.26-.01.41-.34.74-.75.74H6.2zM2.75 6.2v3.6c0 2.58.87 3.45 3.45 3.45h3.09c.24-2.44 1.52-3.71 3.96-3.96V6.2c0-2.58-.87-3.45-3.45-3.45H6.2c-2.58 0-3.45.87-3.45 3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59 6.31a.753.753 0 0 1 .18-1.05c.78-.55 1.83-.56 2.62-.02.34.23.43.7.2 1.04-.23.34-.7.43-1.04.2a.8.8 0 0 0-.9.01c-.15.1-.3.14-.45.14-.23 0-.47-.11-.61-.32zM8.59 6.31a.753.753 0 0 1 .18-1.05c.78-.55 1.83-.56 2.62-.02.34.23.43.7.2 1.04-.23.34-.7.43-1.04.2a.8.8 0 0 0-.9.01c-.15.1-.3.14-.45.14-.23 0-.47-.11-.61-.32zM5.84 12.17c-.71 0-1.29-.58-1.29-1.29 0-1.9 1.55-3.45 3.45-3.45.78 0 1.55.27 2.16.76.32.26.38.73.12 1.05-.26.32-.73.37-1.05.12-.35-.28-.77-.43-1.22-.43-1 0-1.83.76-1.94 1.74h2.1c.41 0 .75.34.75.75s-.35.75-.76.75H5.84z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 22.75c-3.42 0-4.95-1.53-4.95-4.95V14c.06-3.19 1.56-4.69 4.74-4.75h3.81c3.42 0 4.95 1.53 4.95 4.95v3.6c0 3.42-1.53 4.95-4.95 4.95h-3.6zm-3.45-8.74v3.79c0 2.58.87 3.45 3.45 3.45h3.6c2.58 0 3.45-.87 3.45-3.45v-3.6c0-2.58-.87-3.45-3.45-3.45H14c-2.38.04-3.21.87-3.25 3.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77 14.21a.753.753 0 1 1 .87-1.23.8.8 0 0 0 .9.01c.34-.23.81-.15 1.04.2.23.34.15.81-.2 1.04-.39.27-.84.4-1.29.4-.47 0-.93-.14-1.32-.42zM16.77 14.21a.753.753 0 1 1 .87-1.23.8.8 0 0 0 .9.01c.34-.23.81-.15 1.04.2.23.34.15.81-.2 1.04-.39.27-.84.4-1.29.4-.47 0-.93-.14-1.32-.42z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.55 16.72c0-.71.58-1.29 1.29-1.29h4.32c.71 0 1.29.58 1.29 1.29 0 1.9-1.55 3.45-3.45 3.45-1.9 0-3.45-1.55-3.45-3.45zM16 18.67c1.01 0 1.83-.76 1.94-1.74h-3.88c.1.98.93 1.74 1.94 1.74z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSmileys);
export default __webpack_public_path__ + "static/media/vuesax-outline-smileys.2a795d0d76a040e5c8bbbdae9b29090c.svg";
export { ForwardRef as ReactComponent };